<div
    fxLayout="column"
    class="infinite-scroll-bar infinte-scroll"
    fxLayoutGap="16px"
    infinite-scroll
    [infiniteScrollDistance]="2"
    [infiniteScrollThrottle]="100"
    [scrollWindow]="false"
    [style.maxHeight]="'200px'"
>
    <ng-container *ngFor="let item of duplicateClaimCaseList; let i = index">
        <div
            fxLayout="row"
            fxLayoutAlign="start start"
            class="cursor-pointer mb-12"
            id="am-1057"
            [matTooltip]="item.claimNumberInsurance"
            matTooltipPosition="above"
            matTooltipClass="tooltip"
        >
            <div>
                <mat-icon class="font-size-12 badge-yellow mt-4" color="yellow"> lens </mat-icon>
            </div>

            <div [ngClass]="'badge-orange'" fxLayout="column" fxLayoutAlign="start start">
                <div class="font-size-14" fxLayout="row" fxLayoutAlign="start center">
                    <a class="badge-green" href="{{ getRepairCenterClaimUrl(item) }}" target="_blank">{{
                        item.claimNumberInsurance
                    }}</a>
                </div>
            </div>
        </div>
    </ng-container>

    <app-no-data-found *ngIf="duplicateClaimCaseList.length === 0" />
</div>
